import { render, staticRenderFns } from "./Decoration9.vue?vue&type=template&id=3b4df202&scoped=true"
import script from "./Decoration9.vue?vue&type=script&lang=js"
export * from "./Decoration9.vue?vue&type=script&lang=js"
import style0 from "./Decoration9.vue?vue&type=style&index=0&id=3b4df202&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4df202",
  null
  
)

export default component.exports